import PropTypes from 'prop-types'

import { ObjectEbsSettings } from '../../models/ebs/object-ebs-settings-enum'
import { idPropType } from '../common/id-prop-type'

const { LOAD_LIMIT, OBJECT_ID } = ObjectEbsSettings

/**
 * @typedef {Object} ObjectEbsSettings
 *
 * @property {number} [loadLimit]   - The load limit of the Object EBS setting
 * @property {Id} objectId          - The object id unique identifier
 */
export const objectEbsSettingsPropType = PropTypes.shape({
    [LOAD_LIMIT]: PropTypes.number,
    [OBJECT_ID]: idPropType.isRequired
})
